import React from 'react';

import PropTypes from 'prop-types';
import {
    Button,
    Dialog,
    Modal as BaseModal,
    ModalOverlay,
} from 'react-aria-components';

import { Text } from 'wanderu-components';
import { combineClasses } from 'wanderu-css';

import { CloseIcon } from '../Icons';

import styles from './Modal.scss';

const Modal = ({
    children,
    classes: classesProp = {},
    showButton = false,
    title,
    ...otherProps
}) => {
    const classes = combineClasses(styles, classesProp);

    return (
        <ModalOverlay
            className={classes.modalOverlay}
            {...otherProps}
        >
            <BaseModal className={classes.modal}>
                <Dialog className={classes.dialog}>
                    <div className={classes.title}>
                        <Text variant="text-xl" bold>
                            {title}
                        </Text>
                        {showButton && <Button className={classes.button} slot="close">
                            <CloseIcon />
                        </Button>}
                    </div>
                    {children}
                </Dialog>
            </BaseModal>
        </ModalOverlay>
    );
};

Modal.propTypes = {
    children: PropTypes.node,
    classes: PropTypes.object,
    isDismissable: PropTypes.bool,
    isOpen: PropTypes.bool,
    onOpenChange: PropTypes.func,
    showButton: PropTypes.bool,
    title: PropTypes.string,
};

export default Modal;
